/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInclusive = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 4.062A8.004 8.004 0 0 0 4.062 11H2v2h2.062A8.004 8.004 0 0 0 11 19.938V22h2v-2.062A8.004 8.004 0 0 0 19.938 13H22v-2h-2.062A8.004 8.004 0 0 0 13 4.062V2h-2zM12 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm-3 4V8h6v2h-2v4h2v2H9v-2h2v-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInclusive as Inclusive };
